import React from 'react';

export const DovetailSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M32.6 5H7.4C6.07452 5 5 6.07452 5 7.4V32.6C5 33.9255 6.07452 35 7.4 35H32.6C33.9255 35 35 33.9255 35 32.6V7.4C35 6.07452 33.9255 5 32.6 5Z"
			fill="#0C0020"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.2181 22.3104C12.1766 22.3344 12.1766 22.3944 12.2181 22.4185L16.1357 24.6809C16.1742 24.7032 16.198 24.7444 16.198 24.789V29.3125C16.198 29.3606 16.25 29.3906 16.2917 29.3665L20.2091 27.1042C20.2477 27.0819 20.2715 27.0407 20.2715 26.9961V22.4365C20.2715 22.3919 20.2477 22.3507 20.2091 22.3284L16.198 20.0132L12.2181 22.3104Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.2181 12.9029C12.1766 12.9269 12.1766 12.987 12.2181 13.011L16.1357 15.2734C16.1742 15.2957 16.198 15.3369 16.198 15.3815V20.0132L20.2715 17.6607V13.029C20.2715 12.9844 20.2477 12.9432 20.2091 12.9209L16.2604 10.6417C16.2218 10.6194 16.1742 10.6194 16.1357 10.6417L12.2181 12.9029Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.2715 17.6607L24.2826 19.9771C24.3212 19.9994 24.345 20.0406 24.345 20.0852V24.6088C24.345 24.6568 24.397 24.6868 24.4386 24.6628L28.3561 22.4004C28.3947 22.3781 28.4185 22.3369 28.4185 22.2924V17.7327C28.4185 17.6881 28.3947 17.6469 28.3561 17.6247L24.4074 15.3454C24.3688 15.3232 24.3212 15.3232 24.2826 15.3454L20.2715 17.6607Z"
			fill="white"
		/>
	</svg>
);
